import { render, staticRenderFns } from "./PackageConfig.vue?vue&type=template&id=48c8ca45&scoped=true"
import script from "./PackageConfig.vue?vue&type=script&lang=js"
export * from "./PackageConfig.vue?vue&type=script&lang=js"
import style0 from "./PackageConfig.vue?vue&type=style&index=0&id=48c8ca45&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c8ca45",
  null
  
)

export default component.exports